<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>MEDICATION</mat-panel-title>
    </mat-expansion-panel-header>

    <app-medication-autocomplete [patient]="patient" #medicationAutocomplete
        [hidden]="true"></app-medication-autocomplete>

    <div class="clinical-timeline-info">

        <div class="list-header expandable" (click)="toggleHeader('active')">
            Active Medication
            <mat-icon aria-hidden="false" aria-label="Expand/Collapse">
                {{ expandedHeader === 'active' ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <div *ngIf="expandedHeader === 'active'" class="full-width p-t-10">
            <ng-container *ngIf="activeMedication; else listLoading">
                <ng-container *ngIf="activeMedication.length; else noResults">
                    <app-medication-autocomplete [patient]="patient" [hidden]="true"
                        #medicationAutocomplete></app-medication-autocomplete>
                    <div class="chip-container with-actions">
                        <div class="medication-list">
                            <ng-container *ngFor="let med of activeMedication; let last = last">
                                <div class="medication-item">
                                    <div>
                                        <p>{{med.name || med.medication}}</p>
                                        <p class="hint"> {{ med.dose }} {{ med.unit }} {{ med.frequency }}
                                            {{ med.duration }}</p>
                                    </div>
                                    <button mat-icon-button (click)="toggleMedicationActive(med)"
                                        matTooltip="Mark this medication as inactive">
                                        <mat-icon>arrow_downward</mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="container-actions">
                        <!-- <button mat-icon-button matTooltip="Download a new prescription using the active medication"
                            (click)="createNewPrescriptionFromActive(activeMedication)">
                            <mat-icon>file_download</mat-icon>
                        </button> -->
                        <button mat-icon-button matTooltip="Create a prescription using the active medication"
                            (click)="clonePrescriptionMedication(activeMedication)">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>


                </ng-container>
            </ng-container>
        </div>


        <div class="list-header expandable inactive-header" (click)="toggleHeader('inactive')">
            Inactive Medication
            <mat-icon aria-hidden="false" aria-label="Expand/Collapse">
                {{ expandedHeader === 'inactive' ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <div *ngIf="expandedHeader === 'inactive'" class="full-width p-t-10">
            <ng-container *ngIf="inactiveMedication; else listLoading">
                <ng-container *ngIf="inactiveMedication.length; else noResults">
                    <div class="chip-container">
                        <div class="medication-list">
                            <ng-container *ngFor="let med of inactiveMedication; let last = last">
                                <div class="medication-item">
                                    <div>
                                        <p>{{med.name || med.medication}}</p>
                                        <p class="hint"> {{ med.dose }} {{ med.unit }} {{ med.frequency }}
                                            {{ med.duration }}</p>
                                    </div>
                                    <div class="actions">
                                        <button mat-icon-button (click)="toggleMedicationActive(med)"
                                            matTooltip="Mark this medication as active">
                                            <mat-icon>arrow_upward</mat-icon>
                                        </button>
                                        <button mat-icon-button color="warn" (click)="deleteMedication(med)"
                                            matTooltip="Remove this medication from the patient file">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>

                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <div class="list-header expandable prescription-header" (click)="toggleHeader('prescriptions')">
            Past Prescriptions
            <mat-icon aria-hidden="false" aria-label="Expand/Collapse">
                {{ expandedHeader === 'prescriptions' ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <div *ngIf="expandedHeader === 'prescriptions'" class="full-width">
            <ng-container *ngIf="prescriptions; else listLoading">
                <ng-container *ngIf="prescriptions.length; else noResults">
                    <ng-container *ngFor="let group of prescriptions">
                        <div class="list-header">
                            {{ group.date | date: 'longDate' }}
                        </div>
                        <mat-list class="full-width">
                            <ng-container *ngFor="let item of group.items">
                                <mat-list-item class="auto-height">
                                    <div class="note-item">
                                        <div class="note-details">
                                            <div matLine class="note-title">
                                                <span><strong>Prescription ID:</strong> {{ item.prescriptionNumber
                                                    }}</span>
                                            </div>

                                            <div matLine class="note-details preserve-line-breaks"
                                                [innerText]="getMedicationString(item.medication)">
                                            </div>

                                            <div class="list-actions icons">
                                                <button mat-icon-button matTooltip="Send this via email" *ngIf="!stateUnit"
                                                    [matMenuTriggerFor]="emailMenu" #menuTrigger="matMenuTrigger"
                                                    (click)="$event.stopPropagation()">
                                                    <mat-icon>mail</mat-icon>
                                                </button>
                                                <mat-menu #emailMenu="matMenu" class="p-10 email-menu-panel">
                                                    <div mat-menu-content (click)="$event.stopPropagation()">
                                                        <app-signature-options
                                                            [(includeSignature)]="includeSignatureOnEmail"
                                                            [(selectedDoctor)]="selectedDoctor">
                                                        </app-signature-options>
                                                        <app-recipient-search 
                                                            [patient]="patient"
                                                            [patientOnly]="true"
                                                            label="Quick Select Recipient"
                                                            placeholder="Search for recipient..."
                                                            (recipientSelected)="onRecipientSelected($event)">
                                                        </app-recipient-search>
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Recipient Email</mat-label>
                                                            <input matInput [(ngModel)]="sendingDetails.email">
                                                        </mat-form-field>
                                                        <button mat-raised-button color="primary" class="full-width"
                                                            (click)="emailPrescription(item)"
                                                            matTooltip="Send to this email address">
                                                            <mat-icon>send</mat-icon> Send Email
                                                        </button>
                                                    </div>
                                                </mat-menu>

                                                <ng-container *ngIf="canSign; else cantSign">
                                                    <button mat-icon-button matTooltip="Download as PDF"
                                                        [matMenuTriggerFor]="downloadMenu">
                                                        <mat-icon>file_download</mat-icon>
                                                    </button>
                                                    <mat-menu #downloadMenu="matMenu" class="p-10">
                                                        <app-signature-options
                                                            [(includeSignature)]="includeSignatureOnPdf"
                                                            [(selectedDoctor)]="selectedDoctor">
                                                        </app-signature-options>
                                                        <button mat-raised-button color="primary" class="full-width"
                                                            (click)="downloadPrescription(item)">
                                                            Download PDF <mat-icon>file_download</mat-icon>
                                                        </button>
                                                    </mat-menu>
                                                </ng-container>
                                                <ng-template #cantSign>
                                                    <button mat-icon-button matTooltip="Download as PDF"
                                                        (click)="downloadPrescription(item)">
                                                        <mat-icon>file_download</mat-icon>
                                                    </button>
                                                </ng-template>
                                                <button mat-icon-button matTooltip="Clone this prescription"
                                                    (click)="clonePrescriptionMedication(item.medication)">
                                                    <mat-icon>content_copy</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </mat-list-item>
                            </ng-container>
                        </mat-list>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>